import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPage} from '@Components/poster-editor/poster-editor-reducer';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.class';
import {ContextualMenuHeadingOption} from '@Components/contextual-menu/components/contextual-menu-heading-option';
import {BackgroundImageMediaControls} from '@Components/poster-editor/components/poster-editing-side-panel/components/background-image-media-controls';
import {ImageBgBlackAndWhiteOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/image-bg-black-and-white-option';
import {ImageBgSepiaOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/image-bg-sepia-option';
import {ImageBgInvertOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/image-bg-invert-option';
import {ImageBgBrightnessOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/image-bg-brightness-option';
import {ImageBgContrastOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/image-bg-contrast-option';
import {ImageBgVibranceOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/image-bg-vibrance-option';
import {ImageBgSaturationOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/image-bg-saturation-option';
import {ImageBgTintOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/image-bg-tint-option';
import {ImageBgMultiplyOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/image-bg-multiply-option';
import {ImageBgGammaOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/image-bg-gamma-option';
import {PosterEditorDesignSubPanels} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-default-options/poster-editing-default-options.types';
import {ImageBgTransparencyOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/image-bg-transparency-option';
import {useAppSelector} from '@/hooks';

interface ImageBackgroundOptionsProps {
  onClickColorFill(option: PosterEditorDesignSubPanels): void;
}

export function ImageBackgroundOptions({...props}: ImageBackgroundOptionsProps): ReactElement | null {
  const currentPage = useAppSelector(getCurrentPage);

  if (!currentPage) {
    return null;
  }

  if (currentPage.background.details.type !== BackgroundTypeName.IMAGE) {
    return null;
  }

  return (
    <>
      <BackgroundImageMediaControls />
      <ContextualMenuHeadingOption id="page-background-effects-heading" text={window.i18next.t('pmwjs_effects')} />
      <ImageBgBlackAndWhiteOption />
      <ImageBgSepiaOption />
      <ImageBgInvertOption />
      <ContextualMenuHeadingOption id="page-background-adjustment-heading" text={window.i18next.t('pmwjs_adjustments')} />
      <ImageBgBrightnessOption />
      <ImageBgContrastOption />
      <ImageBgVibranceOption />
      <ImageBgSaturationOption />
      <ImageBgTransparencyOption />
      <ImageBgTintOption
        onClickColorFill={(): void => {
          props.onClickColorFill(PosterEditorDesignSubPanels.BACKGROUND_IMAGE_TINT_COLOR);
        }}
      />
      <ImageBgMultiplyOption
        onClickColorFill={(): void => {
          props.onClickColorFill(PosterEditorDesignSubPanels.BACKGROUND_IMAGE_MULTIPLY_COLOR);
        }}
      />
      <ImageBgGammaOption />
    </>
  );
}
